import { render, staticRenderFns } from "./letter-keyboard.vue?vue&type=template&id=23fd1b6a&scoped=true&"
import script from "./letter-keyboard.vue?vue&type=script&lang=js&"
export * from "./letter-keyboard.vue?vue&type=script&lang=js&"
import style0 from "./letter-keyboard.vue?vue&type=style&index=0&id=23fd1b6a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fd1b6a",
  null
  
)

export default component.exports